module.exports = __webpack_public_path__ + "static/media/18ECA36.d845a6f9.jpg";